import { Box, Button, Card, Grid, IconButton, TextField, Tooltip, Typography } from "@mui/material";
import { FC, UIEvent, useEffect, useRef, useState } from "react";

import MaterialReactTable from "material-react-table";
import { API_SLUGS, PatternType } from "../../constants";
import { useTableInfinity } from "../../hooks/process/useTableInfinity";
import { BorderColorOutlined, Close, ContentCopy } from "@mui/icons-material";
import VariableData from "./variableData";
import copy from "copy-to-clipboard";
import { IAlertState, useAlertState } from "../../store/alertState";
import AddVariableForm from "./addVariableForm";
import ModalWrapper from "../common/modal/wrapper";
import { Plus } from "../../icons/plus";
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import { axiosInstance } from "../../services/axios";
import DeleteVariableForm from "./deleteVariableForm";
import VisibilityIcon from '@mui/icons-material/Visibility';
import LanguageIcon from '@mui/icons-material/Language';
import GroupsIcon from '@mui/icons-material/Groups';
var format = require("string-template");

const limit = 30;
const disableInfiniteScroll = false;

const VariablesTable: FC<any> = ({ }) => {
    const path = API_SLUGS.GET_VARIABLES + `?limit={limit}&offset={offset}`;
    const tableContainerRef = useRef<HTMLDivElement>(null);
    const [selectedVariable, setSelectedVariable] = useState("");
    const [hasUnsavedChanges, setHasUnsavedChanges] = useState(false);
    const { setMessage } = useAlertState() as IAlertState;

    const { rows, fetchMoreOnBottomReached, isFetching, resetAndFetch } = useTableInfinity(
        "generators",
        path,
        tableContainerRef,
        limit
    );

    useEffect(() => {
        if (!disableInfiniteScroll) {
            fetchMoreOnBottomReached(tableContainerRef.current);
        }
    }, [fetchMoreOnBottomReached])



    return (
        <Card elevation={0} sx={{ textAlign: "left", overflow: "auto", height: "100%" }}>
                    
                    <MaterialReactTable
                        muiTablePaperProps={{
                            elevation: 0
                        }}
                        enableGlobalFilter={false}
                        columns={[
                            {
                                accessorKey: "name",
                                header: "Patterns",
                                Cell: (params: any) => {
                                    return (<Typography variant='h6'>{params?.row?.original?.name}</Typography>)
                                }
                            },
                            {
                                accessorKey: "id",
                                header: "ID",
                                Cell: (params: any) => (
                                    <pre
                                        style={{ display: "inline", cursor: "pointer" }}
                                        onClick={() => {
                                            copy(
                                                params?.row?.original?.id
                                            );

                                            setMessage({
                                                title: "Pattern ID copied to the clipboard",
                                                type: "success",
                                            });
                                        }}
                                    >
                                        <ContentCopy fontSize="inherit" />
                                        {params?.row?.original?.id.split("-")[0]}
                                    </pre>
                                ),

                            },
                            {
                                accessorKey: "type",
                                header: "Group",
                                Cell: (params: any) => {
                                    const label = params?.row?.original?.groupName;
                                    return (
                                        params?.row?.original?.type === PatternType.GLOBAL ? <Tooltip title='All Groups'><LanguageIcon fontSize="small"/></Tooltip> : 
                                        <Box sx={{display:'flex', alignItems: 'center'}}>
                                            <GroupsIcon fontSize="inherit" sx={{mr:0.5}}/>
                                            <Typography>
                                                {label}
                                            </Typography>
                                        </Box>
                                    )
                                },

                            },
                            {
                                //@ts-ignore
                                accessorKey: "action",
                                header: "Actions",
                                Cell: (params: any) => {
                                    const isReadOnly = params?.row?.original?.isReadOnly;
                                    return (
                                        !isReadOnly ? (<Box sx={{ display: "flex", justifyContent: "start" }}>

                                            <ModalWrapper
                                                maxWidth="md"

                                                title={``}
                                                trigger={
                                                    <Tooltip title='Edit'>
                                                    <Button variant='outlined' size='small' sx={{color: 'text.primary', borderColor: 'neutral.300', mr:1, minWidth: '45px'}}>
                                                        <BorderColorOutlined/>
                                                    </Button>
                                                    </Tooltip>

                                                }
                                                child={
                                                    <Box sx={{ overflow: 'hidden' }}>
                                                        <VariableData
                                                            selectedVariable={params?.row?.original?.id}
                                                            onDataChange={setHasUnsavedChanges}
                                                            isGlobalPattern={params?.row?.original?.type === PatternType.GLOBAL}
                                                        />
                                                    </Box>
                                                }
                                                closeConfirmation={hasUnsavedChanges}
                                                confirmCloseMessage="You have unsaved changes. Are you sure you want to close?"
                                            />


                                            <ModalWrapper
                                                maxWidth="sm"
                                                title="Delete Pattern"
                                                trigger={

                                                    <Tooltip title="Delete">
                                                         <Button color='error' variant='outlined' size='small' sx={{ borderColor: 'neutral.300', mr:1, minWidth: '45px'}}>
                                                         <DeleteOutlineIcon/>
                                                    </Button>
                                                    </Tooltip>

                                                }
                                                child={
                                                    <DeleteVariableForm
                                                        callback={() => resetAndFetch()}
                                                        preventRedirect
                                                        updateUUID={params?.row?.original?.id}
                                                        name={params?.row?.original?.name}
                                                        isGlobalPattern={params?.row?.original?.type === PatternType.GLOBAL}
                                                    />
                                                }
                                            />


                                        </Box>): (<Box sx={{ display: "flex", justifyContent: "start" }}>
                                            <ModalWrapper
                                                maxWidth="md"

                                                title={``}
                                                trigger={
                                                    <Tooltip title='View'>
                                                    <Button variant='outlined' size='small' sx={{color: 'text.primary', borderColor: 'neutral.300', mr:1, minWidth: '45px'}}>
                                                        <VisibilityIcon/>
                                                    </Button>
                                                    </Tooltip>

                                                }
                                                child={
                                                    <Box sx={{ overflow: 'hidden' }}>
                                                        <VariableData
                                                            selectedVariable={params?.row?.original?.id}
                                                            onDataChange={setHasUnsavedChanges}
                                                            isReadOnly={true}
                                                            isGlobalPattern={params?.row?.original?.type === PatternType.GLOBAL}
                                                        />
                                                    </Box>
                                                }
                                                closeConfirmation={hasUnsavedChanges}
                                                confirmCloseMessage="You have unsaved changes. Are you sure you want to close?"
                                            />
                                        </Box>))
                                },

                            },

                        ]}
                        data={rows}
                        
                        initialState={{
                            density: "compact",
                            columnPinning: { left: ['name'] },
                        }}
                        enableColumnActions={false}
                        enableSorting={false}
                        enableStickyHeader


                        enableTopToolbar={false}

                        enablePagination={false}
                        enableDensityToggle={false}
                        enableColumnFilters={false}
                        // enableRowVirtualization
                        state={{
                            showProgressBars: isFetching,
                        }}
                        muiTableContainerProps={{
                            ref: tableContainerRef, //get access to the table container element
                            sx: { maxHeight: "calc(100vh - 270px)" }, //give the table a max height
                            onScroll: (
                                event: UIEvent<HTMLDivElement> //add an event listener to the table container element
                            ) => {
                                if (!disableInfiniteScroll) {
                                    fetchMoreOnBottomReached(event.target as HTMLDivElement)
                                }

                            }
                        }}
                    />
                </Card>
           
    );
};

export default VariablesTable;